import { Col, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

import { AppletProps, Category, FrequentlyAskedQuestion } from "./types";

import { AppletWrapper } from "~/Atom/AppletWrapper";
import { ESAccordionGroup } from "~/Atom/ESAccordionGroup";
import { useFlag } from "~/LaunchDarkly";
import { useOmnichannelApi } from "~/OmnichannelApi";

const Applet: React.FC<AppletProps> = ({ categorySlug }) => {
  const hasAuthorization = useFlag("applet-es-rental-categories-faq-accordion");
  const api = useOmnichannelApi();
  const [rentalCategoriesFAQs, setRentalCategoriesFAQs] =
    useState<FrequentlyAskedQuestion[]>();

  useEffect(() => {
    api["static.webflow.collections.items.get"]({
      collection_slug: "categories",
      path_name: "items",
      item_slug: categorySlug,
      file_type: "json",
    }).then((res) => {
      const collectionData = res.data as Category;

      const rentalCategoriesFAQsData: FrequentlyAskedQuestion[] =
        collectionData.frequently_asked_questions;
      setRentalCategoriesFAQs(
        rentalCategoriesFAQsData //.sort((a, b) =>a.sort_order < b.sort_order ? -1 : 1)
      );
    });
  }, [categorySlug]);

  if (!hasAuthorization || !rentalCategoriesFAQs?.length) {
    return null;
  }

  return (
    <Row>
      <Col xs={24}>
        <Typography.Title level={2}>
          {"Frequently Asked Questions"}
        </Typography.Title>
      </Col>

      <ESAccordionGroup
        itemsArray={
          rentalCategoriesFAQs as unknown as Array<Record<string, string>>
        }
        labelKey={"name"}
        contentKey={"answer"}
      />
    </Row>
  );
};

export const mount = (el: HTMLDivElement) => {
  const root = createRoot(el);

  const getAttr = (attr: string, defaultValue?: string) =>
    el.getAttribute(attr) || defaultValue;

  const categorySlug = getAttr("categoryslug");

  if (categorySlug) {
    root.render(
      <AppletWrapper appletName="rental-categories-faq-accordion">
        <Applet categorySlug={categorySlug} />
      </AppletWrapper>
    );
  } else {
    console.log(`Unable to identify category: ${categorySlug}`);
  }
};
